module.exports = __webpack_public_path__ + "img/Avatar-46.82b4a2e3.svg";